import { render, staticRenderFns } from "./DiscourseIcon.vue?vue&type=template&id=098eac00&lang=pug&"
import script from "./DiscourseIcon.vue?vue&type=script&lang=js&"
export * from "./DiscourseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports